import { PurchaseOrderStatus } from "@/redux/services/inventory/inventory.type";
import { cn } from "@/lib/utils";

const STYLES: Record<PurchaseOrderStatus, string> = {
  draft: "bg-slate-100 text-slate-700",
  sent: "bg-blue-100 text-blue-700",
  partially_received: "bg-amber-100 text-amber-700",
  received: "bg-green-100 text-green-700",
  cancelled: "bg-red-100 text-red-700",
};

const LABELS: Record<PurchaseOrderStatus, string> = {
  draft: "Brouillon",
  sent: "Envoyé",
  partially_received: "Partiellement reçu",
  received: "Reçu",
  cancelled: "Annulé",
};

interface PurchaseOrderStatusBadgeProps {
  status: PurchaseOrderStatus;
}

const PurchaseOrderStatusBadge = ({ status }: PurchaseOrderStatusBadgeProps) => (
  <span
    className={cn(
      "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
      STYLES[status]
    )}
  >
    {LABELS[status]}
  </span>
);

export default PurchaseOrderStatusBadge;
